const FunderWebUrl = "https://pathwayz.sportzvillage.com/funder/#/";
// const FunderWebUrl = "https://sportingbharat.com/funder_webpage/#/";

export default FunderWebUrl; 
